import React, { useState } from 'react'

import encoding from 'encoding-japanese'
import { usePapaParse } from 'react-papaparse'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import { csvArrayToJson } from '../../../../../../util/csvArrayToJson'
import { useSelector } from 'react-redux'
import configUserRole from '../../../../../../config/userRole'
import { selectRole } from '../../../../../../slices/authSlice'

type CsvUploadProps = {
  setUpload: React.Dispatch<React.SetStateAction<ContactAddressType[]>>
}

const CSVUpload = (props: CsvUploadProps) => {
  const { setUpload } = props
  const { readString } = usePapaParse()
  const loginUserRole: number = useSelector(selectRole)

  const reader = new FileReader()

  const initialLabelText = (
    <span>
      クリックしてファイルを選択
      <br />
      or
      <br />
      ドラッグ＆ドロップしてください
    </span>
  )

  const [labelTextJSX, setLabelTextJSX] =
    useState<JSX.Element>(initialLabelText)

  const dragoverListener = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    e.currentTarget.style.background = '#e1e7f0'
  }

  const dragleaveListener = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    e.currentTarget.style.background = 'rgba(0,0,0,0)'
  }

  const dropListener = async (e: React.DragEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()
    e.currentTarget.style.background = 'rgba(0,0,0,0)'

    const files = Array.from(e.dataTransfer.items)
      .map((item: any) => item.getAsFile())
      .filter((file): file is File => file !== null)

    const selectedFile = files[0]

    if (selectedFile) encodeAndUploadFile(selectedFile)
  }

  const changeListener = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    const selectedFile = e.target.files[0]

    if (selectedFile) encodeAndUploadFile(selectedFile)
  }

  const encodeAndUploadFile = (file: File) => {
    reader.readAsArrayBuffer(file)

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const fileContent = e.target && e.target.result
      const codes = new Uint8Array(fileContent as ArrayBuffer)

      const csvData = encoding.convert(codes, {
        to: 'UNICODE',
        type: 'string',
      })
      
      uploadCSVData(csvData, file)
    }
  }

  const uploadCSVData = (csvData: string, file: File) => {
    readString(csvData, {
      worker: true,
      complete: (results: any) => {
        const jsonData = csvArrayToJson(results.data, loginUserRole, configUserRole)
        if (jsonData) {
          setLabelTextJSX(<span>{file ? file.name : initialLabelText}</span>)
          setUpload(jsonData as ContactAddressType[])
        }
      },
    })
  }

  return (
    <div
      id="DropZone"
      style={{ border: '1px dashed' }}
      onDragOver={dragoverListener}
      onDragLeave={dragleaveListener}
      onDrop={(e) => dropListener(e)}
      onChange={(e) => changeListener(e)}
    >
      <input type="file" id="uploadfile" style={{ display: 'none' }} />
      <label
        htmlFor="uploadfile"
        id="fileLabel"
        style={{ padding: '30px', width: '100%', textAlign: 'center' }}
      >
        {labelTextJSX}
      </label>
    </div>
  )
}

export default CSVUpload
